import type { ApiClient } from "@/clients/ApiClient";

/**
 * Events the app reports: what was played, which feeds visitors wish for. Nobody waits for them,
 * so none of these rejects; an event that cannot be sent is dropped.
 */
export interface TrackingApi {
    userAction(client: string, action: string, payload?: unknown): Promise<void>;
    episodeAction(episodeId: number, client: string, action: string, payload?: unknown): Promise<void>;
    /** A feed address a visitor would like added */
    suggest(client: string, url: string): Promise<void>;
}

export const createTrackingApi = (client: ApiClient): TrackingApi => {
    const send = async (path: string, body: unknown) => {
        try {
            await client.post(path, body);
        } catch {
            // tracking must never get in the visitor's way
        }
    };

    return {
        userAction: (clientId, action, payload = {}) => send("/user/action", { action, payload, client: clientId }),
        episodeAction: (episodeId, clientId, action, payload = {}) =>
            send(`/episodes/${episodeId}/action`, { action, payload, client: clientId }),
        suggest: (clientId, url) => send("/podcasts/suggest", { client: clientId, url }),
    };
};
